/**
 * Bundle block (Kaching app), in the theme style:
 * - the coloured circle emojis in front of the pack names (🟢 🔵 ⚫ …) become small cubes in the
 *   same colour, like the brand's pixel blocks;
 * - the emojis in the badges (🏆 ⭐ …) become shiny coloured icons (gold gradient, white shine) with
 *   the same dark outline as the other icons of the shop.
 * The texts themselves are not changed. The app draws the block after the page has loaded and redraws
 * it when a pack is chosen, so a MutationObserver on the page keeps the icons in place.
 * Loaded only when Theme settings → "Pixel decorations" → "Bundle block in the theme style" is on.
 */
(function () {
  if (window.__kgPackCubes) return;
  window.__kgPackCubes = true;

  // top, left and right face of the cube for each circle emoji
  var CUBES = {
    '🟢': ['#c2ea8a', '#8fd61f', '#6a9e22'],
    '🔵': ['#7dd8fd', '#15bcfb', '#0796d6'],
    '⚫': ['#6b7a8a', '#2b3a4a', '#0b2540'],
    '🔴': ['#f59aa1', '#e63946', '#b3242f'],
    '🟡': ['#ffe39a', '#ffc93c', '#e0a400'],
    '🟠': ['#ffc08f', '#ff7f1f', '#cc5f0d'],
    '🟣': ['#c9b3fb', '#8e5cf7', '#6435c9'],
    '⚪': ['#ffffff', '#e6ebf0', '#c7d0d9'],
    '🟤': ['#c9a07c', '#8a5a33', '#633d1f'],
  };
  var CIRCLE = /^\s*(🟢|🔵|⚫|🔴|🟡|🟠|🟣|⚪|🟤)️?\s*/;

  var OUTLINE = 'stroke="#0b2540" stroke-linejoin="round"';
  var uid = 0;

  // shiny gold: light top, warm bottom (each icon gets its own gradient id)
  function gold(id) {
    return (
      '<defs><linearGradient id="' + id + '" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0" stop-color="#fff6c2"/><stop offset=".45" stop-color="#ffd23f"/><stop offset="1" stop-color="#e39b00"/>' +
      '</linearGradient></defs>'
    );
  }
  var SPARKLE = '<path d="M26.5 2l.8 2.1 2.1.8-2.1.8-.8 2.1-.8-2.1-2.1-.8 2.1-.8z" fill="#fff"/>';
  var SHINE = 'fill="none" stroke="#fff" stroke-opacity=".85" stroke-width="1.5" stroke-linecap="round"';

  function star(g) {
    return (
      gold(g) +
      '<path d="M16 3l3.9 8 8.8 1.2-6.4 6.1 1.6 8.7L16 22.8l-7.9 4.2 1.6-8.7-6.4-6.1 8.8-1.2z" fill="url(#' + g + ')" stroke-width="1.6" ' + OUTLINE + '/>' +
      '<path d="M12.8 12.4l2.2-4.6" ' + SHINE + '/>' +
      SPARKLE
    );
  }

  var BADGE_ICONS = {
    '🏆': function (g) {
      var handles = 'M9.5 7.5H6v2a4.5 4.5 0 0 0 4.5 4.5M22.5 7.5H26v2a4.5 4.5 0 0 1-4.5 4.5';
      return (
        gold(g) +
        '<path d="' + handles + '" fill="none" stroke="#0b2540" stroke-width="3.4" stroke-linecap="round"/>' +
        '<path d="' + handles + '" fill="none" stroke="url(#' + g + ')" stroke-width="1.6" stroke-linecap="round"/>' +
        '<path d="M9 5h14v6.5a7 7 0 0 1-14 0z" fill="url(#' + g + ')" stroke-width="1.6" ' + OUTLINE + '/>' +
        '<path d="M12.2 7.5v3.6a4 4 0 0 0 1.6 3.2" ' + SHINE + '/>' +
        '<path d="M14 18.5h4v3.5h-4z" fill="#e39b00" stroke-width="1.4" ' + OUTLINE + '/>' +
        '<path d="M10.5 22h11v4.5h-11z" fill="url(#' + g + ')" stroke-width="1.6" ' + OUTLINE + '/>' +
        SPARKLE
      );
    },
    '⭐': star,
    '🌟': star,
    '👑': function (g) {
      return (
        gold(g) +
        '<path d="M5 23 3.5 11l7 5.5L16 7l5.5 9.5 7-5.5L27 23z" fill="url(#' + g + ')" stroke-width="1.6" ' + OUTLINE + '/>' +
        '<path d="M5 23h22v3.5H5z" fill="#e39b00" stroke-width="1.6" ' + OUTLINE + '/>' +
        '<path d="M8 19.5l-.6-4" ' + SHINE + '/>' +
        SPARKLE
      );
    },
    '💎': function () {
      return (
        '<path d="M9 6h14l5.5 7L16 27 3.5 13z" fill="#7dd8fd" stroke-width="1.6" ' + OUTLINE + '/>' +
        '<path d="M3.5 13h25M12.5 6 10 13l6 14 6-14-2.5-7" fill="none" stroke-width="1.2" ' + OUTLINE + '/>' +
        '<path d="M11 8.5l-1.6 2.5" ' + SHINE + '/>' +
        SPARKLE
      );
    },
    '✨': function (g) {
      return (
        gold(g) +
        '<path d="M13 4l2.2 6.3 6.3 2.2-6.3 2.2L13 21l-2.2-6.3-6.3-2.2 6.3-2.2z" fill="url(#' + g + ')" stroke-width="1.4" ' + OUTLINE + '/>' +
        '<path d="M24 17l1.2 3.3 3.3 1.2-3.3 1.2L24 26l-1.2-3.3-3.3-1.2 3.3-1.2z" fill="url(#' + g + ')" stroke-width="1.2" ' + OUTLINE + '/>'
      );
    },
    '🎁': function () {
      return (
        '<rect x="6" y="14" width="20" height="13" rx="1.5" fill="#e63946" stroke-width="1.6" ' + OUTLINE + '/>' +
        '<rect x="4.5" y="9.5" width="23" height="5" rx="1.2" fill="#f2545f" stroke-width="1.6" ' + OUTLINE + '/>' +
        '<path d="M14.5 9.5h3v17.5h-3z" fill="#ffc93c" stroke-width="1.1" ' + OUTLINE + '/>' +
        '<path d="M16 9.5c-1.5-4-6.2-4.6-6.2-1.8 0 1.6 2.7 1.8 6.2 1.8zm0 0c1.5-4 6.2-4.6 6.2-1.8 0 1.6-2.7 1.8-6.2 1.8z" fill="#ffc93c" stroke-width="1.3" ' + OUTLINE + '/>'
      );
    },
  };
  var BADGE_EMOJI = /\s*(🏆|⭐|🌟|👑|💎|✨|🎁)️?\s*/g;

  function icon(className, viewBox, paths) {
    var span = document.createElement('span');
    span.className = className;
    span.setAttribute('aria-hidden', 'true');
    span.innerHTML = '<svg viewBox="' + viewBox + '" focusable="false">' + paths + '</svg>';
    return span;
  }

  function cube(faces) {
    return icon(
      'kg-pack-cube',
      '0 0 40 44',
      '<path d="M20 2 38 12 20 22 2 12Z" fill="' + faces[0] + '"/>' +
        '<path d="M2 12 20 22v20L2 32Z" fill="' + faces[1] + '"/>' +
        '<path d="M38 12 20 22v20l18-10Z" fill="' + faces[2] + '"/>'
    );
  }

  function firstText(element) {
    return Array.prototype.find.call(element.childNodes, function (node) {
      return node.nodeType === 3 && node.nodeValue.trim();
    });
  }

  function updateTitles(block) {
    block.querySelectorAll('.kaching-bundles__bar-title').forEach(function (title) {
      var text = firstText(title);
      if (!text) return;
      var match = text.nodeValue.match(CIRCLE);
      if (!match || !CUBES[match[1]]) return;
      text.nodeValue = text.nodeValue.slice(match[0].length);
      if (!title.querySelector('.kg-pack-cube')) title.insertBefore(cube(CUBES[match[1]]), text);
    });
  }

  function updateBadges(block) {
    block.querySelectorAll('.kaching-bundles__bar-most-popular__content').forEach(function (badge) {
      var text = firstText(badge);
      if (!text) return;
      var found = text.nodeValue.match(BADGE_EMOJI);
      if (!found) return;
      var leading = text.nodeValue.search(BADGE_EMOJI) === 0 && text.nodeValue.trim().length > found[0].trim().length;
      text.nodeValue = text.nodeValue.replace(BADGE_EMOJI, ' ').trim();
      if (badge.querySelector('.kg-badge-icon')) return;
      var emoji = found[0].trim().replace('️', '');
      var svg = icon('kg-badge-icon', '0 0 32 32', BADGE_ICONS[emoji]('kgGold' + ++uid));
      badge.insertBefore(svg, leading ? text : text.nextSibling);
    });
  }

  function update(block) {
    updateTitles(block);
    updateBadges(block);
  }

  // The app draws (and redraws) the block some time after the page has loaded, sometimes replacing
  // the element itself, so watch the whole page and update at most once per frame.
  var scheduled = false;

  function run() {
    scheduled = false;
    document.querySelectorAll('kaching-bundles-block').forEach(update);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(run);
  }

  function init() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
